import { render, staticRenderFns } from "./ListSubMerchants.vue?vue&type=template&id=6340a544&scoped=true&"
import script from "./ListSubMerchants.vue?vue&type=script&lang=js&"
export * from "./ListSubMerchants.vue?vue&type=script&lang=js&"
import style0 from "./ListSubMerchants.vue?vue&type=style&index=0&id=6340a544&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6340a544",
  null
  
)

export default component.exports